import { CompanyInfo, PartnerContact, PartnerLogos } from "@api";

import partnerInfo from "../partner-info.json";

export type PartnerInfo = {
  name: string;
  url: string;
  logo: PartnerLogos;
  contact: PartnerContact;
  companyInfo: CompanyInfo;
  providers: string[];
};

export const usePartnerInfo = (): PartnerInfo => {
  return partnerInfo;
};
